/* eslint-disable @typescript-eslint/no-explicit-any */
import { Action, ActionReducer, MetaReducer } from '@ngrx/store';
import { AREAS_FEATURE_KEY } from '@us/web/areas/data-access';
import { AUTH_FEATURE_KEY } from '@us/web/auth/data-access';
import { CART_FEATURE_KEY } from '@us/web/cart/data-access';
import { ORDERS_FEATURE_KEY } from '@us/web/orders/data-access';
import { POSITION_FEATURE_KEY } from '@us/web/position/data-access';
import { PREFERENCE_FEATURE_KEY } from '@us/web/preferences/data-access';
import { SHOP_FEATURE_KEY } from '@us/web/shop/data-access';
import { merge } from 'lodash';
import { localStorageSync } from 'ngrx-store-localstorage';

const INIT_ACTION = '@ngrx/store/init';
const UPDATE_ACTION = '@ngrx/store/update-reducers';

const mergeReducer = (state: any, rehydratedState: any, action: Action): any => {
    if ((action.type === INIT_ACTION || action.type === UPDATE_ACTION) && rehydratedState) {
        state = merge(state, rehydratedState);
    }
    return state;
};

const localStorageSyncReducer = (reducer: ActionReducer<any>): ActionReducer<any> =>
    localStorageSync({
        keys: [
            AUTH_FEATURE_KEY,
            CART_FEATURE_KEY,
            SHOP_FEATURE_KEY,
            ORDERS_FEATURE_KEY,
            AREAS_FEATURE_KEY,
            PREFERENCE_FEATURE_KEY,
            POSITION_FEATURE_KEY
        ],
        rehydrate: true,
        restoreDates: false, // !IMPORTANT
        mergeReducer
    })(reducer);

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];
